import React, { useState, useEffect } from "react";
import Header from "../OrderManagement/Header"; // Adjust the path as needed
import {
  Box,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  Tabs,
  Tab,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";

import {
  Person as PersonIcon,
  Home as HomeIcon,
  LocalShipping as LocalShippingIcon,
  Apartment as ApartmentIcon,
  LocationOn as LocationOnIcon,
  Place as PlaceIcon,
  Pin as PinIcon,
  Public as PublicIcon,
  Flag as FlagIcon,
  LocationCity as LocationCityIcon,
  TextFields as TextFieldsIcon,
  Inbox as InboxIcon,
} from "@mui/icons-material";

import Input from "../../ui/Input";
import DateField from "../../ui/DateField";
import Time from "../../ui/Time";
import { headers } from "../../utils/utils";

const Form = () => {
  const [customer, setCustomer] = useState({
    customerName: "",
    customerCode: "",
    customerType: "Customer",
    addresses: [
      {
        unitNumber: "",
        addressLine1: "",
        addressLine2: "",
        zipcode: "",
        country: "",
        state: "",
        city: "",
        addressType: "Billing Address",
      },
    ],
    customFields: {},
  });

  const [addressList, setAddressList] = useState([
    { country: "", state: "", stateList: [], city: "", cityList: [] },
  ]);
  const [countries, setCountries] = useState([]);
  const [customField, setCustomField] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [isSameAddress, setIsSameAddress] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomer({ ...customer, [name]: value });
  };

  const handleAddAddress = () => {
    setCustomer({
      ...customer,
      addresses: [
        ...customer.addresses,
        {
          unitNumber: "",
          addressLine1: "",
          addressLine2: "",
          zipcode: "",
          country: "",
          state: "",
          city: "",
          addressType: "Shipping Address",
          customFields: {},
        },
      ],
    });
    setAddressList([
      ...addressList,
      { country: "", state: "", stateList: [], city: "", cityList: [] },
    ]);
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        "https://customer.eVyoog.com/customer/save",
        {
          method: "POST",
          body: JSON.stringify(customer),
          headers: headers(),
        },
      );
      if (response.ok) {
        const result = await response.json();
        console.log("Customer saved successfully:", result);

        if (result.id) {
          setCustomer((prevFormData) => ({
            ...prevFormData,
            id: result.id,
          }));
        }
      }
      setCustomer({
        customerName: "",
        customerCode: "",
        customerType: "Customer",
        addresses: [
          {
            unitNumber: "",
            addressLine1: "",
            addressLine2: "",
            zipcode: "",
            country: "",
            state: "",
            city: "",
            addressType: "",
          },
        ],
        customFields: {},
      });
    } catch (error) {
      console.error("Error creating customer:", error);
      alert("Failed to create customer.");
    }
  };

  useEffect(() => {
    handleAddAddress();
    const fetchCustomFields = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SYS_CONFIG_MGMT}/systemConfig/getDynamicFields?screenName=Customer Screen`,
          {
            method: "GET",
            headers: headers(),
          },
        );
        if (!response.ok) {
          throw new Error("Failed to fetch custom fields");
        }
        const data = await response.json();
        setCustomField(data);
        console.log("Fetched Custom Fields:", data);
      } catch (error) {
        console.error("Error fetching custom fields:", error);
      }
    };

    fetchCustomFields();
  }, []);

  const handleCustomFieldChange = (key, value) => {
    setCustomer((prevCustomer) => ({
      ...prevCustomer,
      customFields: {
        ...prevCustomer.customFields,
        [key]: value,
      },
    }));
  };

  const handleAddressChange = (index, e) => {
    const { name, value } = e.target;
    const updatedAddresses = [...customer.addresses];
    updatedAddresses[index][name] = value;

    if (isSameAddress && index === 0) {
      updatedAddresses[1] = {
        ...updatedAddresses[0],
        addressType: "Shipping Address",
      };
    }

    setCustomer({ ...customer, addresses: updatedAddresses });
  };

  const updateAddress = (index, name, value) => {
    const updatedAddresses = [...customer.addresses];
    updatedAddresses[index][name] = value;

    setCustomer({ ...customer, addresses: updatedAddresses });
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(
          "https://countriesnow.space/api/v0.1/countries",
        );
        const data = await response.json();
        setCountries(data.data.map((country) => country.country));
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  const fetchStates = async (index, country) => {
    try {
      const response = await fetch(
        "https://countriesnow.space/api/v0.1/countries/states",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ country }),
        },
      );

      const data = await response.json();
      if (!data.error) {
        const updatedAddresses = [...addressList];
        updatedAddresses[index]["country"] = country;
        updatedAddresses[index]["stateList"] = data.data.states.map(
          (state) => state.name,
        );
        updateAddress(index, "country", country);
        updateAddress(index, "state", "");
        setAddressList(updatedAddresses);
      } else {
        console.error("Error fetching states:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCities = async (index, country, state) => {
    try {
      const response = await fetch(
        "https://countriesnow.space/api/v0.1/countries/state/cities",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ country, state }),
        },
      );

      const data = await response.json();
      if (!data.error) {
        const updatedAddresses = [...addressList];
        updatedAddresses[index]["state"] = state;
        updatedAddresses[index]["cityList"] = data.data;
        updateAddress(index, "state", state);
        updateAddress(index, "city", "");
        console.log("updatedAddresses", updatedAddresses);
        setAddressList(updatedAddresses);
      } else {
        console.error("Error fetching cities:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const updateSelectedCity = (index, city) => {
    const updatedAddresses = [...addressList];
    updatedAddresses[index]["city"] = city;
    updateAddress(index, "city", city);
    setAddressList(updatedAddresses);
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSameAddressToggle = (event) => {
    const checked = event.target.checked;
    setIsSameAddress(checked);

    if (checked) {
      copyBillingAddressToShipping();
    } else {
      resetShippingAddress();
    }
  };

  const copyBillingAddressToShipping = () => {
    setCustomer((prevCustomer) => {
      const updatedAddresses = [...prevCustomer.addresses];
      updatedAddresses[1] = {
        ...updatedAddresses[0],
        addressType: "Shipping Address",
        country: updatedAddresses[0].country,
        state: updatedAddresses[0].state,
        city: updatedAddresses[0].city,
      };
      return { ...prevCustomer, addresses: updatedAddresses };
    });

    setAddressList((prevAddressList) => {
      const updatedAddressList = [...prevAddressList];
      updatedAddressList[1] = {
        ...updatedAddressList[0],
        country: updatedAddressList[0].country,
        state: updatedAddressList[0].state,
        city: updatedAddressList[0].city,
      };
      return updatedAddressList;
    });
  };

  const resetShippingAddress = () => {
    setCustomer((prevCustomer) => {
      const updatedAddresses = [...prevCustomer.addresses];
      updatedAddresses[1] = {
        unitNumber: "",
        addressLine1: "",
        addressLine2: "",
        zipcode: "",
        country: "",
        state: "",
        city: "",
        addressType: "Shipping Address",
      };
      return { ...prevCustomer, addresses: updatedAddresses };
    });

    setAddressList((prevAddressList) => {
      const updatedAddressList = [...prevAddressList];
      updatedAddressList[1] = {
        country: "",
        state: "",
        stateList: [],
        city: "",
        cityList: [],
      };
      return updatedAddressList;
    });
  };

  return (
    <>
      <Header />

      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: 100,
          borderRadius: 2,
          background: "white",
        }}
      >
        <div
          className="form-label"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h3 style={{ display: "flex", alignItems: "center" }}>
            <InboxIcon /> Customer
          </h3>
        </div>

        <Box p={2}>
          <Grid container spacing={5} className="form-l1">
            <Input
              label="Customer Name"
              name="customerName"
              icon={PersonIcon}
              grid="12"
              placeHolder="Customer"
              onChange={handleInputChange}
            />

            {customField.map((field, index) => {
              const fieldKey = field.label;

              const InputComponent =
                field.inputType === "text"
                  ? Input
                  : field.inputType === "date"
                    ? DateField
                    : field.inputType === "time"
                      ? Time
                      : field.inputType === "select"
                        ? Select
                        : Input;

              return (
                <InputComponent
                  key={fieldKey}
                  label={field.label}
                  icon={TextFieldsIcon}
                  grid="3"
                  value={customer.customFields[fieldKey] || ""}
                  onChange={(e) =>
                    handleCustomFieldChange(fieldKey, e.target.value)
                  }
                  placeHolder={field.placeholder}
                />
              );
            })}
          </Grid>
          <hr className="hr" />
          <br />
        </Box>

        <Tabs
          value={tabValue}
          onChange={handleChange}
          centered
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: 16,
              fontWeight: "bold",
            },
            "& .Mui-selected": { color: "#1976D2" },
          }}
        >
          <Tab icon={<HomeIcon />} label="Billing Address" />
          <Tab icon={<LocalShippingIcon />} label="Shipping Address" />
        </Tabs>

        <Box sx={{ padding: 3 }}>
          {customer.addresses.map(
            (address, index) =>
              tabValue === index && (
                <Grid container spacing={5} className="form-l1" key={index}>
                  {index === 1 && (
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isSameAddress}
                            onChange={handleSameAddressToggle}
                          />
                        }
                        label="Same as Billing Address"
                      />
                    </Grid>
                  )}

                  <Input
                    label="Unit Number"
                    name="unitNumber"
                    icon={ApartmentIcon}
                    grid="3"
                    value={address.unitNumber}
                    placeHolder="Unit Number"
                    onChange={(e) => handleAddressChange(index, e)}
                    disabled={index === 1 && isSameAddress}
                  />
                  <Input
                    label="Address Line 1"
                    name="addressLine1"
                    icon={LocationOnIcon}
                    grid="6"
                    value={address.addressLine1}
                    placeHolder="Address Line 1"
                    onChange={(e) => handleAddressChange(index, e)}
                    disabled={index === 1 && isSameAddress}
                  />
                  <Input
                    label="Address Line 2"
                    name="addressLine2"
                    icon={PlaceIcon}
                    grid="3"
                    value={address.addressLine2}
                    placeHolder="Address Line 2"
                    onChange={(e) => handleAddressChange(index, e)}
                    disabled={index === 1 && isSameAddress}
                  />

                  <Grid item xs="3">
                    <Box
                      component="span"
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        fontSize: "14px",
                      }}
                    >
                      <PublicIcon /> Country
                    </Box>
                    <FormControl fullWidth>
                      <Select
                        value={address.country}
                        displayEmpty
                        onChange={(e) => {
                          fetchStates(index, e.target.value);
                          handleAddressChange(index, e);
                        }}
                        disabled={index === 1 && isSameAddress}
                      >
                        <MenuItem value="" disabled>
                          Select Country
                        </MenuItem>
                        {countries.map((country) => (
                          <MenuItem key={country} value={country}>
                            {country}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs="3">
                    <Box
                      component="span"
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        fontSize: "14px",
                      }}
                    >
                      <FlagIcon /> State
                    </Box>
                    <FormControl
                      fullWidth
                      disabled={
                        !address.country || (index === 1 && isSameAddress)
                      }
                    >
                      <Select
                        value={address.state}
                        displayEmpty
                        onChange={(e) =>
                          fetchCities(index, address.country, e.target.value)
                        }
                      >
                        <MenuItem value="" disabled>
                          Select State
                        </MenuItem>
                        {addressList[index].stateList.map((state) => (
                          <MenuItem key={state} value={state}>
                            {state}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs="3">
                    <Box
                      component="span"
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        fontSize: "14px",
                      }}
                    >
                      <LocationCityIcon /> City
                    </Box>
                    <FormControl
                      fullWidth
                      disabled={
                        !address.state || (index === 1 && isSameAddress)
                      }
                    >
                      <Select
                        value={address.city}
                        displayEmpty
                        onChange={(e) =>
                          updateSelectedCity(index, e.target.value)
                        }
                      >
                        <MenuItem value="" disabled>
                          Select City
                        </MenuItem>
                        {addressList[index].cityList.map((city) => (
                          <MenuItem key={city} value={city}>
                            {city}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Input
                    label="Zipcode"
                    name="zipcode"
                    icon={PinIcon}
                    grid="3"
                    value={address.zipcode}
                    placeHolder="Zipcode"
                    onChange={(e) => handleAddressChange(index, e)}
                    disabled={index === 1 && isSameAddress}
                  />
                </Grid>
              ),
          )}
        </Box>

        <br />
        <br />
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Create Customer
          </Button>
        </Grid>
      </Box>
      <br />
    </>
  );
};

export default Form;
